import {Translations} from './backendTranslations-types';
import {TranslationsAction} from './backendTranslations-actions';

const initialState: Translations = {
    translations: []
};

export function backendTranslationsReducer(state: Translations = initialState, action: TranslationsAction): Translations {
    switch (action.type) {
        case 'TRANSLATIONS_LOADED': {
            return {
                ...action.translations,
            };
        }
        default:
            return state;
    }
}
